import { SimpleErrorObject } from './responses';

export class CustomError {
  public name: string = 'CustomError';
  public code: number = 500;
  public message: string = 'An unknown error occurred';
  public stack?: string;

  constructor(message?: unknown) {
    // If the message is a string, set it as the error message
    if (typeof message === 'string') {
      this.message = message;
    }

    // If the message is an object, try to parse it as an API error response
    const error = SimpleErrorObject.safeParse(message);
    if (error.success) {
      this.message = error.data.message;
    }

    this.stack = Error().stack;
  }

  toJSON() {
    return {
      name: this.name,
      code: this.code,
      message: this.message,
      stack: this.stack
    };
  }
}

interface Response {
  status: number;
  body: unknown;
}

export class APIError extends CustomError {
  static fromResponse(response: Response) {
    switch (response.status) {
      case 400:
        return new BadRequestError(response.body);
      case 403:
        return new ForbiddenError(response.body);
      case 404:
        return new NotFoundError(response.body);
      case 500:
        return new CriticalError(response.body);
      default:
        return new APIError();
    }
  }
}

export class CriticalError extends CustomError {
  name: string = 'CriticalError';
  code: number = 500;
  constructor(message?: unknown) {
    super(message);
    if (!message || (typeof message === 'object' && !('message' in message))) {
      this.message = 'An unknown error occurred';
    }
  }
}

export class BadRequestError extends CustomError {
  name: string = 'BadRequestError';
  code: number = 400;
  constructor(message?: unknown) {
    super(message);
    if (!message || (typeof message === 'object' && !('message' in message))) {
      this.message = 'The request was malformed';
    }
  }
}

export class ForbiddenError extends CustomError {
  name: string = 'ForbiddenError';
  code: number = 403;
  constructor(message?: unknown) {
    super(message);
    if (!message || (typeof message === 'object' && !('message' in message))) {
      this.message = 'You are not authorized to perform this action';
    }
  }
}

export class NotFoundError extends CustomError {
  name: string = 'NotFoundError';
  code: number = 404;
  constructor(message?: unknown) {
    super(message);
    if (!message || (typeof message === 'object' && !('message' in message))) {
      this.message = 'The requested resource was not found';
    }
  }
}
